<template>
  <div>
    <!--dashboard main body start-->
    <div class="pt-0">
      <div class="-content d-flex align-items-start flex-column">
        <div class="page-global-header px-0">
          <div class="row mx-0 justify-content-center">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 offset-xl-3 offset-xxl-3"
            >
              <div class="global-searchbar">
                <form class="base-form" @submit.prevent>
                  <div class="input-group">
                    <div class="input-group-text javaBlue">
                      <img src="@/assets/images/system/file-icon.svg" />
                    </div>
                    <input
                      type="search"
                      v-model="form.search_field"
                      name="globalSearch"
                      class="form-control"
                      placeholder="Search (Business name, client name, email, invoice number etc)"
                    />
                    <button type="submit" name="btnSearch" class="btn btn-javaBlue">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </form>
                <div v-if="errorMessage">{{ errorMessage }}</div>
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-3 d-flex align-items-center justify-content-end"
              style="padding-right: 20px;"
            >
              <ul class="search-option-menu me-3">
                <li class="nav-item">
                  <XlsToggle v-model="xlsView" title="Switch between XLS grid and default invoice list" />
                </li>
                <li class="nav-item">
                  <a
                    href="#"
                    class="nav-link list-view"
                    :class="{ 'view-active': viewMode === 'list' }"
                    title="List view"
                    @click.prevent="setViewMode('list')"
                  >
                    <img src="@/assets/images/system/list-icon.png" />
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="#"
                    class="nav-link grid-view"
                    :class="{ 'view-active': viewMode === 'group' }"
                    title="Group view (group invoices by client)"
                    @click.prevent="setViewMode('group')"
                  >
                    <img src="@/assets/images/system/grid-icon.png" />
                  </a>
                </li>
                <li class="nav-item sorting">
                  <input
                    type="checkbox"
                    class="sorting-check"
                    id="btn-sorting"
                    autocomplete="off"
                    v-model="invoice_sorting_desc"
                    @change="changeOrder"
                  />
                  <label class="btn btn-sorting" for="btn-sorting"
                    ><span class="sr-only">Sort</span>
                  </label>
                </li>
                <li class="nav-item">
                  <router-link to="/add-invoice" class="nav-link circleNav"
                    ><i class="fa fa-plus"></i>
                  </router-link>
                </li>
                <li class="nav-item dropdown">
                  <a
                    href="#"
                    class="nav-link dropdown-toggle no-caret"
                    id="optionMore"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    ><i class="fa fa-ellipsis-v"></i>
                  </a>
                  <ul
                    class="dropdown-menu dropdown-menu-end _v1"
                    aria-labelledby="optionMore"
                  >
                    <li>
                      <a class="dropdown-item" href="#" @click.prevent="downloadPdf"
                        >PDF <i class="fa fa-envelope append"></i>
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#" @click.prevent="generateExcel"
                        >Download Excel <i class="fa fa-download append"></i>
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#" @click.prevent="downloadZip"
                        >Download Zip <i class="fa fa-download append"></i>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>

          <div class="row mx-0">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10 col-xxl-10 mx-auto mt-3">
              <div class="global-filter-form">
                <form class="base-form form-xl">
                  <div class="row g-2 d-flex justify-content-center">
                    <div class="col-sm-2">
                      <div class="form-floating">
                        <input
                          type="date"
                          name="datepick"
                          id="startDate"
                          class="form-control datepicker text-end text-danger _3d-input chevron-circle"
                          v-model="form.start_date"
                          @change="searchData"
                          onfocus="this.showPicker()"
                          data-date-format="mm/dd/yyyy"
                        />
                        <label for="startDate" class="w-100 text-center"
                          >Start date</label
                        >
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="form-floating">
                        <input
                          type="date"
                          name="datepick"
                          id="endDate"
                          class="form-control datepicker text-end text-danger _3d-input chevron-circle"
                          v-model="form.end_date"
                          @change="searchData"
                          onfocus="this.showPicker()"
                          data-date-format="mm/dd/yyyy"
                        />
                        <label for="endDate" class="w-100 text-center"
                          >End date</label
                        >
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <select
                        class="form-select _3d-input text-black"
                        v-model="form.category"
                        @change="searchData"
                      >
                        <option selected="" disabled="" value="">
                          Select invoice category (all)
                        </option>
                        <option value="all">All</option>
                        <option value="paid">Paid</option>
                        <option value="unpaid">Unpaid</option>
                        <option value="unpaiddue">Unpaid due</option>
                        <option value="partpaid">Part paid</option>
                        <option value="partpaiddue">Part paid due</option>
                        <option value="draft">Draft</option>
                        <option value="void">Void</option>
                      </select>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div class="page-body custom-scroll">
          <!--group view : phase 1 - list of clients the invoices were sent to-->
          <div
            class="row mt-3 mx-0"
            v-if="!xlsView && viewMode === 'group' && !selectedClient"
          >
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 offset-xl-3 offset-xxl-3">
              <div class="group-breadcrumb">
                <span class="crumb-spacer"></span>
                <span class="crumb-title">Clients</span>
                <span class="crumb-count">
                  {{ groupedClients.length }}
                  {{ groupedClients.length === 1 ? "client" : "clients" }}
                </span>
              </div>
              <div class="card-list-group">
                <div class="group-empty" v-if="!groupedClients.length">
                  No clients found for the selected date range.
                </div>
                <!--repeatable block-->
                <div
                  class="card card-horizontal-list javaBlue group-client-card"
                  v-for="(group, index) in groupedClients"
                  :key="group.key"
                  @click="openClientGroup(group.key)"
                >
                  <div class="card-body">
                    <div class="card-content count-inline flex-shrink-0">
                      <ul class="label-list">
                        <li class="list-title"><span class="card-count">{{ index + 1 }}.</span>{{ group.business_name }}</li>
                        <li class="sub-title" v-if="group.name">N: {{ group.name }}</li>
                        <li class="text-danger">
                          D: {{ group.first_date }} - {{ group.last_date }}
                        </li>
                        <li>E: {{ group.email }}</li>
                      </ul>
                      <ul class="card-action-nav flex-start-horizontal mt-3">
                        <li class="nav-item">
                          <a href="#" class="btn btn-primary btn-sm" @click.prevent="openClientGroup(group.key)">
                            <i class="fa fa-file-alt"></i>
                            {{ group.invoices.length }}
                            {{ group.invoices.length === 1 ? "Invoice" : "Invoices" }}
                          </a>
                        </li>
                        <li class="nav-item ms-2" v-if="group.unpaid_count">
                          <a href="#" class="btn btn-azureBlue btn-sm" @click.prevent="openClientGroup(group.key)">
                            <i class="fa fa-dollar-sign"></i> {{ group.unpaid_count }} Outstanding
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="card-footer has-action flex-shrink-1">
                    <div class="footer-list-wraper justify-content-end">
                      <ul class="footer-list has-border-bottom">
                        <li>Total</li>
                        <li class="count">
                          {{ $auth.user?.currency }} {{ group.total.toFixed(2) }}
                        </li>
                      </ul>

                      <ul class="footer-list highlight has-border-bottom">
                        <li>Paid</li>
                        <li class="count">
                          {{ $auth.user?.currency }} {{ group.paid.toFixed(2) }}
                        </li>
                      </ul>

                      <ul class="footer-list _big">
                        <li>Balance Due</li>
                        <li class="count">
                          {{ $auth.user?.currency }} {{ group.balance.toFixed(2) }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--list view, and group view : phase 2 - invoices of the selected client-->
          <div class="row mt-3 mx-0" v-else-if="!xlsView">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 offset-xl-3 offset-xxl-3">
              <div class="group-breadcrumb" v-if="viewMode === 'group' && selectedClient">
                <a href="#" class="back-link" @click.prevent="backToClients">
                  <i class="fa fa-chevron-left"></i> All clients
                </a>
                <span class="crumb-title">{{ selectedClient.business_name }}</span>
                <span class="crumb-count">
                  {{ selectedClient.invoices.length }}
                  {{ selectedClient.invoices.length === 1 ? "invoice" : "invoices" }}
                </span>
              </div>
              <div class="card-list-group">
                <!--repeatable block-->
                <div
                  class="card card-horizontal-list javaBlue"
                  v-for="(invoice, index) in visibleInvoices"
                  :key="invoice.invoice_id"
                >
                  <div class="card-body">
                    <div class="hover-slide">
                      <div class="form-check outliner">
                        <input class="form-check-input" type="checkbox" value="" />
                      </div>
                    </div>
                    <div class="card-content count-inline flex-shrink-0">
                      <ul class="label-list">
                        <li class="list-title"><span class="card-count">{{ index + 1 }}.</span>{{ invoice.client.business_name }}</li>
                        <li class="sub-title">IN: {{ invoice.invoice_number }}</li>
                        <li class="text-danger">
                          D: {{ $formatDate(invoice.invoice_date) }} -
                          {{ $formatDate(invoice.expiry_date) }}
                        </li>
                        <li>E: {{ invoice.client.email }}</li>
                      </ul>
                      <ul class="card-action-nav flex-start-horizontal mt-3">
                        <li class="nav-item" v-if="invoice.invoice_status == 'paid'">
                          <a href="#" class="btn btn-success btn-sm status-badge"
                            ><i class="fa fa-dollar-sign"></i> Paid
                          </a>
                        </li>
                        <li class="nav-item" v-else-if="invoice.invoice_status == 'partpaid' || invoice.invoice_status == 'partpaiddue'">
                          <a href="#" class="btn btn-alert btn-sm status-badge"
                            ><i class="fa fa-dollar-sign"></i> Part Payment
                          </a>
                        </li>
                        <li class="nav-item" v-else-if="invoice.invoice_status == 'unpaid' || invoice.invoice_status == 'unpaiddue' || invoice.invoice_status == 'draft' || invoice.invoice_status == 'sent'">
                          <a href="#" class="btn btn-azureBlue btn-sm status-badge"
                            ><i class="fa fa-dollar-sign"></i> Nil
                          </a>
                        </li>
                        <li class="nav-item" v-if="invoice.total_discount_amount > 0">
                          <a href="#" class="btn btn-secondary btn-sm"
                            ><i class="fa fa-percent"></i> Discount
                          </a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="invoice.invoice_attachments.filename != 'N/A'"
                        >
                          <a
                            href="#"
                            class="btn btn-primary btn-sm"
                            data-bs-toggle="modal"
                            data-bs-target="#expenseFile"
                            @click="showDetails(invoice.invoice_number, 'file')"
                            ><i class="fa fa-paperclip"></i> File
                          </a>
                        </li>
                        <li class="nav-item ms-2" v-if="hasNote(invoice)">
                          <a
                            href="#"
                            class="btn btn-info btn-sm"
                            data-bs-toggle="modal"
                            data-bs-target="#expenseFile"
                            @click="showDetails(invoice.invoice_number, 'note')"
                            ><i class="fa fa-edit"></i> Note
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="card-footer has-action flex-shrink-1">
                    <div class="ellipsis-dropdown dropdown">
                      <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link">
                          <i class="fas fa-ellipsis-v text-white"></i>
                        </span>
                        <template #dropdown>
                          <el-dropdown-menu>
                            <el-dropdown-item
                              :command="{ action: 'edit', id: invoice.invoice_number }"
                              ><i class="fa fa-edit"></i> Edit
                            </el-dropdown-item>
                            <el-dropdown-item
                              @click="
                                confirmVoid(invoice.invoice_id, invoice.invoice_number)
                              "
                              ><i class="fa fa-times text-danger"></i> Void
                            </el-dropdown-item>
                            <!-- <el-dropdown-item
                            @click="
                              deleteData(invoice.invoice_id, invoice.client.client_id)
                            "
                            ><i class="fa fa-times"></i
                          ></el-dropdown-item> -->
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                    </div>
                    <ul class="log-status _sm center">
                      <li class="list-item overdue" v-if="isOverdue(invoice)">
                        <a href="#"><i class="fas fa-hourglass-end"></i> Overdue</a>
                      </li>
                      <li class="list-item draft" v-if="invoice.invoice_type == 'draft'">
                        <a href="#"><i class="fas fa-hourglass-end"></i> Draft</a>
                      </li>
                      <li class="list-item void" v-if="invoice.invoice_type == 'void'">
                        <a href="#"><i class="fas fa-hourglass-end"></i> Void</a>
                      </li>
                    </ul>
                    <div class="footer-list-wraper justify-content-end">
                      <ul class="footer-list has-border-bottom">
                        <li>Total</li>
                        <li class="count">
                          {{ $auth.user?.currency }} {{ amountNet(invoice).toFixed(2) }}
                        </li>
                      </ul>

                      <ul class="footer-list highlight has-border-bottom">
                        <li>Paid</li>
                        <li class="count">
                          {{ $auth.user?.currency }} {{ amountPaid(invoice).toFixed(2) }}
                        </li>
                      </ul>

                      <ul class="footer-list _big">
                        <li>Balance Due</li>
                        <li class="count">
                          {{ $auth.user?.currency }} {{ balanceDue(invoice).toFixed(2) }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3 mx-0" v-else>
            <div class="col-12 xls-grid-col">
              <ExcelGridView
                :columns="xlsColumns"
                :rows="xlsRows"
                :totals="xlsTotals"
                :currency-symbol="$auth.user?.currency || '£'"
                no-data-text="No invoices match the current filters."
                @cell-click="onXlsCellClick"
              />
            </div>
          </div>

          <div class="row mx-0 mt-5" v-if="!xlsView && visibleTotalCards.length">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 offset-xl-3 offset-xxl-3">
              <div class="d-flex justify-content-end">
                <div
                  v-for="(card, index) in visibleTotalCards"
                  :key="card.key"
                  class="card-totalCount"
                  :class="[card.cssClass, { 'ms-4': index > 0 }]"
                >
                  <div class="card-header">{{ card.label }}</div>
                  <div class="card-body">
                    {{ $auth.user?.currency || '£' }} {{ card.value.toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!--dashboard main body end-->
    <div class="pb-5"></div>

    <!--Expense File Preview Modal-->
    <div
      class="modal fade mdl-messaging _info"
      id="expenseFile"
      aria-hidden="true"
      aria-labelledby="expenseFileLabel"
      tabindex="-1"
    >
      <div class="modal-dialog">
        <div class="modal-dialog-header">
          <div class="header-title">Expense preview</div>
        </div>
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body pt-0">
            <div class="message-card no-shadow m-1">
              <div class="abs-nav abs--tr me-n5">
                <ul class="nav flex-column">
                  <li class="nav-item">
                    <router-link
                      class="nav-link"
                      :to="'/edit-invoice/' + popup_data.invoice_number"
                      ><i class="fa fa-edit"></i>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#"><i class="fa fa-print"></i> </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#"><i class="fa fa-envelope"></i> </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link"><i class="fa fa-download"></i> </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link"><i class="fas fa-ban"></i> </a>
                  </li>
                </ul>
              </div>

              <div class="w-90">
                <ul class="list-group list-group--borderless list-group--compact">
                  <li class="list-group-item">
                    Invoice number: {{ popup_data.invoice_number }}
                  </li>
                  <li class="list-group-item">
                    Invoice date: {{ $formatDate(popup_data.invoice_date) }}
                  </li>
                  <li class="list-group-item">
                    Vendor name: {{ popup_data.business_name }}
                  </li>
                  <li class="list-group-item">Vendor email: {{ popup_data.email }}</li>
                  <li class="list-group-item">Name: {{ popup_data.name }}</li>
                  <li class="list-group-item d-flex justify-content-between">
                    <span
                      >Total Amount: {{ popup_data.currency_symbol }}
                      {{ popup_data.total_amount_net }}</span
                    >
                  </li>
                  <li class="list-group-item d-flex justify-content-between">
                    <span
                      >Amount Paid: {{ popup_data.currency_symbol }}
                      {{ Math.abs(popup_data.total_amount_paid) }}</span
                    >
                  </li>
                </ul>
              </div>

              <div class="card card--curve-05rem mt-3" v-if="showNote == 'note'">
                <div class="card-body">
                  <p class="m-0">Note:</p>
                  <p class="m-0">
                    {{ popup_data.notes }}
                  </p>
                </div>
              </div>

              <div
                class="card card--curve-05rem mt-3 w-100 align-items-center justify-content-center"
                v-if="showNote == 'file'"
              >
                <div class="w-auto p-2">
                  <div
                    v-for="(images_invoice, key) in popup_data.invoice_attachments"
                    v-bind:key="'inv_img' + key"
                  >
                    <img :src="images_invoice.url" class="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import XlsToggle from "@/components/partials/XlsToggle.vue";
import ExcelGridView from "@/components/partials/ExcelGridView.vue";
import {
  resolveExportFilename,
  unwrapExportUrl,
  downloadExportFromUrl,
  saveBlob,
  readBlobError,
  readRequestError,
  exportErrorMessage,
  EXPORT_PREFIX,
} from "@/utils/exportNaming";
import { resolveCurrencyCode } from "@/utils/currencyCode";

export default {
  name: "ListInvoiceComponent",
  components: { XlsToggle, ExcelGridView },

  data() {
    return {
      loadingInstance: null,
      show_total_expense: 0,
      errorMessage: "",
      xlsView: false,
      viewMode: "list", // "list" = flat invoice list, "group" = grouped by client
      selectedClientKey: null, // set once a client is opened in group view
      invoice_server_data: [],
      form: {
        search_field: "",
        start_date: "",
        category: "all",
        end_date: new Date().toISOString().split("T")[0],
      },
      popup_data: {
        invoice_number: "",
        total_amount_net: "",
        total_amount_paid: "",
        invoice_attachments: "",
        business_name: "",
        email: "",
        name: "",
        notes: "",
        currency_symbol: "",
        invoice_date: "",
      },
      invoice_sorting_desc: false,
      showNote: false,
    };
  },
  created() {},
  mounted() {
    // Set start date to six months before
    const currentDate = new Date();
    const sixMonthsBefore = new Date(currentDate);
    sixMonthsBefore.setMonth(currentDate.getMonth() - 6);
    this.form.start_date = sixMonthsBefore.toISOString().split("T")[0];
    this.getData();
  },
  methods: {
    showPdf(invoiceData) {
      localStorage.setItem("invoice-details", JSON.stringify(invoiceData));
      this.$router.push({ name: "show-invoice" });
    },
    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
        fullscreen: true,
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    handleCommand(command) {
      if (command.action === "edit") {
        // Navigate to the edit page
        this.$router.push(`/edit-invoice/${command.id}`);
      }
    },
    validateForm() {
      if (!this.form.start_date) {
        this.errorMessage = "Start date is required";
        return false;
      }
      if (!this.form.end_date) {
        this.errorMessage = "End date is required";
        return false;
      }
      // Additional validations can be added here, such as date format checks
      return true;
    },
    async searchData() {
      this.invoice_server_data = [];
      this.selectedClientKey = null;
      await this.getData();
    },
    setViewMode(mode) {
      this.viewMode = mode;
      // always land on the client listing when switching into group view
      this.selectedClientKey = null;
    },
    clientKey(invoice) {
      const client = invoice.client || {};
      return String(
        client.client_id || client.email || client.business_name || "unknown"
      );
    },
    openClientGroup(key) {
      this.selectedClientKey = key;
    },
    backToClients() {
      this.selectedClientKey = null;
    },
    showDetails(id, note) {
      this.$store
        .dispatch("invoice/getInvoiceByNumber", { invoice_number: id })
        .then((res) => {
          if (res.data.status == 1) {
            this.showNote = note;
            this.popup_data.invoice_number = res.data.response.invoice_number;
            this.popup_data.invoice_date = res.data.response.invoice_date;
            this.popup_data.total_amount_net = res.data.response.total_amount_net;
            this.popup_data.total_amount_paid = res.data.response.total_amount_paid;
            this.popup_data.invoice_attachments = res.data.response.invoice_attachments;
            this.popup_data.business_name = res.data.response.client.business_name;
            this.popup_data.email = res.data.response.client.email;
            this.popup_data.name = res.data.response.client.name;
            const rawNote = res.data.response.notes || res.data.response.description || res.data.response.note || res.data.response.client?.notes || "";
            this.popup_data.notes = (rawNote && String(rawNote).trim().toUpperCase() !== "N/A") ? rawNote : "";
            this.popup_data.currency_symbol = res.data.response.currency.symbol;
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    async getData() {
      this.showLoading();
      const data = {
        from_date: this.form.start_date,
        to_date: this.form.end_date,
        category: this.form.category,
      };

      if (this.validateForm()) {
        await this.$store
          .dispatch("invoice/searchList", data)
          .then((res) => {
            if (res.data.status == 1) {
              this.invoice_server_data = res.data.response;
            } else {
              // Handle API message gracefully
              const errorMsg =
                res.data.message?.length > 0
                  ? Array.isArray(res.data.message)
                    ? res.data.message.join("\n")
                    : res.data.message
                  : "Something went wrong. Please try again.";

              this.$toast.error(errorMsg);
            }
          })
          .catch((err) => {
            console.log(err);
            // only show a fallback if no message was displayed
            if (err.response && err.response.status === 404) {
              this.$toast.error("Resource not found");
            }
          })
          .finally(() => {
            this.hideLoading();
          });
      } else {
        this.hideLoading();
      }
    },
    deleteData(invoiceId, client_id) {
      this.showLoading();
      this.$store
        .dispatch("invoice/deleteInvoice", {
          invoice_id: invoiceId,
          client_id: client_id,
        })
        .then((res) => {
          //   console.log(res);
          if (res.status == 1) {
            this.$toast.success("Delete Successful.");
            this.$nextTick(() => {
              this.getData();
            });
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    confirmVoid(invoiceId, invoiceNumber) {
      this.$confirm(
        `Are you sure you want to void invoice "${invoiceNumber}"?`,
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.voidData(invoiceId);
        })
        .catch(() => {});
    },
    voidData(invoiceId) {
      this.showLoading();
      this.$store
        .dispatch("invoice/voidInvoice", { invoice_id: invoiceId })
        .then((res) => {
          //   console.log(res);
          if (res.status == 1) {
            this.$toast.success("Void Successful.");
            this.$nextTick(() => {
              this.getData();
            });
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    // The API sends the money fields as strings, and as "N/A"/null on invoices
    // that were never paid against, so anything unparseable has to read as zero
    // - subtracting it raw turns the balance into NaN and the card then falls
    // back to 0.00 on the invoices that actually owe the full amount.
    amountNet(invoice) {
      return parseFloat(invoice.total_amount_net) || 0;
    },
    // Payments come back negative on some records, so the magnitude is what
    // counts as paid.
    amountPaid(invoice) {
      return Math.abs(parseFloat(invoice.total_amount_paid) || 0);
    },
    balanceDue(invoice) {
      return this.roundMoney(this.amountNet(invoice) - this.amountPaid(invoice));
    },
    // Float subtraction leaves a settled invoice a fraction of a cent off,
    // which would render as "-0.00".
    roundMoney(value) {
      const rounded = Math.round(value * 100) / 100;
      return rounded === 0 ? 0 : rounded;
    },
    sumTotals(list) {
      const gross = list.reduce((sum, item) => sum + this.amountNet(item), 0);
      const paid = list.reduce((sum, item) => sum + this.amountPaid(item), 0);
      const balance = list.reduce((sum, item) => sum + this.balanceDue(item), 0);
      return {
        gross: this.roundMoney(gross),
        paid: this.roundMoney(paid),
        balance: this.roundMoney(balance),
      };
    },
    // An invoice is overdue when money is still owed on it and the due date has
    // already passed. Anything settled, voided or still a draft never counts.
    isOverdue(invoice) {
      if (invoice.invoice_type == "void" || invoice.invoice_type == "draft") return false;

      const status = invoice.invoice_status;
      if (status == "paid" || status == "void" || status == "draft") return false;

      // Nothing left to chase (covers overpayments too).
      if (this.balanceDue(invoice) <= 0) return false;

      // The API already resolves due-ness for these two.
      if (status == "unpaiddue" || status == "partpaiddue") return true;

      return this.isPastDue(invoice.expiry_date);
    },
    // Date-only comparison: the API sends yyyy-mm-dd, so building a Date from it
    // would land on UTC midnight and read as "past" for most of the due day in
    // any positive offset. An invoice due today is not yet overdue.
    isPastDue(expiryDate) {
      const match = String(expiryDate ?? "").match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!match) return false;

      const [, year, month, day] = match;
      const due = new Date(+year, +month - 1, +day);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return due < today;
    },
    changeOrder() {
      if (this.invoice_sorting_desc) {
        // Sort data in descending order
        this.invoice_server_data.sort(
          (a, b) => new Date(b.invoice_date) - new Date(a.invoice_date)
        );
      } else {
        // Sort data in ascending order
        this.invoice_server_data.sort(
          (a, b) => new Date(a.invoice_date) - new Date(b.invoice_date)
        );
      }
    },
    // The payload every invoice export endpoint takes. `from`/`to` go alongside
    // `start_date`/`end_date` because the server prefers the latter but still
    // falls back to the former.
    exportFilters() {
      return {
        start_date: this.form.start_date,
        end_date: this.form.end_date,
        from: this.form.start_date,
        to: this.form.end_date,
      };
    },
    // The invoice list has no currency filter, so the fallback name uses the
    // signed-in user's currency. Only reached when the server names nothing.
    exportCurrencyCode() {
      return resolveCurrencyCode(this.$store.state.auth.user?.currency_id);
    },
    async generateExcel() {
      this.showLoading();

      try {
        const res = await this.$store.dispatch("invoice/exportXlxs", this.exportFilters());

        const url = unwrapExportUrl(res.data);
        if (!url) {
          this.$toast.error("Download URL not found");
          return;
        }

        const filename = resolveExportFilename({
          fileName: res.data?.file_name,
          currencyCode: await this.exportCurrencyCode(),
          prefix: EXPORT_PREFIX.invoice,
          extension: "xlsx",
        });

        await downloadExportFromUrl(url, filename);
      } catch (err) {
        console.error(err);
        const message = await readRequestError(err);
        this.$toast.error(
          message ||
            exportErrorMessage(err, "Could not generate the Excel file. Please try again.")
        );
      } finally {
        this.hideLoading();
      }
    },
    async downloadPdf() {
      this.showLoading();

      try {
        const res = await this.$store.dispatch("invoice/generatePdf", this.exportFilters());
        const blob = new Blob([res.data], { type: "application/pdf" });

        // Defence in depth: a failure should now always be non-2xx, but a JSON
        // body arriving as HTTP 200 would otherwise be saved as a broken .pdf.
        const serverError = await readBlobError(blob);
        if (serverError) {
          this.$toast.error(serverError);
          return;
        }

        saveBlob(
          blob,
          resolveExportFilename({
            headers: res.headers,
            currencyCode: await this.exportCurrencyCode(),
            prefix: EXPORT_PREFIX.invoice,
            extension: "pdf",
          })
        );
      } catch (err) {
        console.error(err);
        const message = await readRequestError(err);
        this.$toast.error(
          message || exportErrorMessage(err, "Could not generate the PDF. Please try again.")
        );
      } finally {
        this.hideLoading();
      }
    },
    async downloadZip() {
      this.showLoading();

      try {
        const res = await this.$store.dispatch("invoice/generateZip", this.exportFilters());

        const zipUrl = unwrapExportUrl(res.data);
        if (!zipUrl) {
          this.$toast.error("Download URL not found");
          return;
        }

        const filename = resolveExportFilename({
          fileName: res.data?.file_name,
          currencyCode: await this.exportCurrencyCode(),
          prefix: EXPORT_PREFIX.invoice,
          extension: "zip",
        });

        await downloadExportFromUrl(zipUrl, filename);
      } catch (err) {
        console.error(err);
        const message = await readRequestError(err);
        this.$toast.error(
          message ||
            exportErrorMessage(err, "Could not generate the ZIP file. Please try again.")
        );
      } finally {
        this.hideLoading();
      }
    },
    xlsStatusColor(status) {
      const map = {
        paid: "xls-badge-green",
        partpaid: "xls-badge-orange",
        partpaiddue: "xls-badge-orange",
        unpaid: "xls-badge-blue",
        unpaiddue: "xls-badge-blue",
        draft: "xls-badge-brown",
        sent: "xls-badge-blue",
        void: "xls-badge-red",
      };
      return map[status] || "xls-badge-blue";
    },
    // The API packs the payment category and the overdue flag into a single
    // string ("partpaiddue"). The grid shows them as two columns, so split
    // them: Category is how much has been paid, Status is the exception.
    xlsCategoryLabel(status) {
      const map = {
        paid: "Paid",
        partpaid: "Part paid",
        partpaiddue: "Part paid",
        unpaid: "Unpaid",
        unpaiddue: "Unpaid",
        draft: "Unpaid",
        sent: "Unpaid",
        void: "Unpaid",
      };
      return map[status] || "Unpaid";
    },
    xlsStatusFlag(invoice) {
      const type = String(invoice.invoice_type ?? "").toLowerCase();
      const status = String(invoice.invoice_status ?? "").toLowerCase();
      if (type === "void" || status === "void")
        return { label: "Void", color: "xls-badge-red" };
      if (type === "draft" || status === "draft")
        return { label: "Draft", color: "xls-badge-brown" };
      if (this.isOverdue(invoice))
        return { label: "Due", color: "xls-badge-purple" };
      return { label: "n/a", color: "" };
    },
    onXlsCellClick({ key, row }) {
      if (key === "note") this.showDetails(row._invoice_number, "note");
      if (key === "attachment") this.showDetails(row._invoice_number, "file");
    },
    hasNote(invoice) {
      if (!invoice) return false;
      const noteContent =
        invoice.notes ||
        invoice.description ||
        invoice.note ||
        invoice.client?.notes;
      return (
        noteContent != null &&
        String(noteContent).trim() !== "" &&
        String(noteContent).trim().toUpperCase() !== "N/A"
      );
    },
  },
  computed: {
    // The search box filters the loaded list in the browser (same policy as the
    // client list) - the API ignores a search term, so asking it to filter
    // returned nothing at all.
    filteredInvoices() {
      if (!this.form.search_field) return this.invoice_server_data;

      const query = this.form.search_field.toLowerCase();
      const has = (value) => String(value ?? "").toLowerCase().includes(query);

      return this.invoice_server_data.filter((invoice) => {
        const client = invoice.client || {};
        return (
          has(client.business_name) ||
          has(client.full_name) ||
          has(client.name) ||
          has(client.email) ||
          has(client.phone1) ||
          has(invoice.invoice_number) ||
          has(invoice.notes) ||
          has(invoice.description) ||
          has(invoice.note)
        );
      });
    },
    // invoices currently on screen: the searched list, or just the opened
    // client's invoices in group view
    visibleInvoices() {
      if (this.viewMode === "group" && this.selectedClient) {
        return this.selectedClient.invoices;
      }
      return this.filteredInvoices;
    },
    // group view phase 1: one entry per client the invoices were sent to
    groupedClients() {
      const map = new Map();

      this.filteredInvoices.forEach((invoice) => {
        const key = this.clientKey(invoice);
        const client = invoice.client || {};

        if (!map.has(key)) {
          map.set(key, {
            key,
            business_name: client.business_name || client.name || "N/A",
            name: client.name || "",
            email: client.email || "",
            invoices: [],
            unpaid_count: 0,
            first_date: "",
            last_date: "",
            first_ts: null,
            last_ts: null,
            total: 0,
            paid: 0,
            balance: 0,
          });
        }

        const group = map.get(key);
        group.invoices.push(invoice);

        if (invoice.invoice_status !== "paid" && invoice.invoice_type !== "void") {
          group.unpaid_count += 1;
        }

        const ts = new Date(invoice.invoice_date).getTime();
        if (!isNaN(ts)) {
          if (group.first_ts === null || ts < group.first_ts) {
            group.first_ts = ts;
            group.first_date = invoice.invoice_date;
          }
          if (group.last_ts === null || ts > group.last_ts) {
            group.last_ts = ts;
            group.last_date = invoice.invoice_date;
          }
        }
      });

      const groups = Array.from(map.values()).map((group) => {
        const totals = this.sumTotals(group.invoices);
        return {
          ...group,
          total: totals.gross,
          paid: totals.paid,
          balance: totals.balance,
        };
      });

      // follow the same sort toggle as the flat list, using each client's latest invoice
      groups.sort((a, b) => {
        const aTs = a.last_ts === null ? 0 : a.last_ts;
        const bTs = b.last_ts === null ? 0 : b.last_ts;
        return this.invoice_sorting_desc ? bTs - aTs : aTs - bTs;
      });

      return groups;
    },
    selectedClient() {
      if (!this.selectedClientKey) return null;
      return (
        this.groupedClients.find((group) => group.key === this.selectedClientKey) || null
      );
    },
    totalGross() {
      return this.sumTotals(this.visibleInvoices).gross;
    },
    totalPaid() {
      return this.sumTotals(this.visibleInvoices).paid;
    },
    totalBalance() {
      return this.sumTotals(this.visibleInvoices).balance;
    },
    visibleTotalCards() {
      // No cards when no specific invoice category is selected
      // (i.e. "All" or the placeholder).
      if (this.form.category === "all" || this.form.category === "") return [];

      const total = {
        key: "total",
        label: "Total",
        cssClass: "card-totalCount--total",
        value: this.totalGross,
      };
      const paid = {
        key: "paid",
        label: "Paid",
        cssClass: "card-totalCount--paid",
        value: this.totalPaid,
      };
      const balance = {
        key: "balance",
        label: "Balance Due",
        cssClass: "card-totalCount--ballance",
        value: this.totalBalance,
      };

      switch (this.form.category) {
        // Fully settled invoices - only the paid amount is meaningful.
        case "paid":
          return [paid];
        // Nothing has been paid on these, so the total is the amount owed.
        case "unpaid":
        case "unpaiddue":
        case "draft":
        case "void":
          return [total];
        // Part payments need the full picture.
        default:
          return [total, paid, balance];
      }
    },
    // A rate only belongs in the header when every listed record shares it -
    // with mixed rates the "(20%)" would be wrong for some of the rows.
    xlsTaxLabel() {
      return (base, field) => {
        const rates = new Set(
          this.visibleInvoices.map((invoice) => parseFloat(invoice[field]) || 0)
        );
        return rates.size === 1 ? base + " (" + [...rates][0] + "%)" : base;
      };
    },
    xlsColumns() {
      return [
        { key: "no", label: "No.", align: "center" },
        { key: "invoice_date", label: "Invoice Date", align: "left", date: true },
        { key: "expiry_date", label: "Due Date", align: "left", date: true },
        { key: "invoice_number", label: "Invoice No.", align: "left" },
        { key: "client_name", label: "Client Name", align: "left", totalLabel: "Total" },
        { key: "amount", label: "Amount", align: "right", money: true, total: true },
        { key: "discount", label: "Discount", align: "right", money: true, total: true },
        { key: "sub_total", label: "Sub-total", align: "right", money: true, total: true },
        {
          key: "tax1",
          label: this.xlsTaxLabel("Tax/Vat 1", "vat_percent"),
          align: "right",
          money: true,
          total: true,
        },
        {
          key: "tax2",
          label: this.xlsTaxLabel("Tax/Vat 2", "tax1_percent"),
          align: "right",
          money: true,
          total: true,
        },
        { key: "total", label: "Total", align: "right", money: true, total: true },
        { key: "payments", label: "Payments", align: "right", money: true, total: true },
        {
          key: "outstanding",
          label: "Balance Due",
          align: "right",
          money: true,
          total: true,
          totalAccent: true,
        },
        { key: "category", label: "Category", align: "center", fill: true },
        { key: "status", label: "Status", align: "center", fill: true },
        { key: "note", label: "Note", align: "center", link: true },
        { key: "attachment", label: "Attachment", align: "center", link: true },
      ];
    },
    xlsRows() {
      return this.visibleInvoices.map((invoice, index) => {
        // `sub_total` is already net of the discount, so the pre-discount
        // amount has to be added back for the row to read left to right:
        // Amount - Discount = Sub-total, plus the taxes = Total.
        const discount = parseFloat(invoice.total_discount_amount) || 0;
        const subTotal = parseFloat(invoice.sub_total) || 0;
        const total = this.amountNet(invoice);
        const paid = this.amountPaid(invoice);
        const flag = this.xlsStatusFlag(invoice);
        const hasNote = this.hasNote(invoice);
        const hasFile =
          invoice.invoice_attachments &&
          invoice.invoice_attachments.filename !== "N/A";
        return {
          no: index + 1,
          invoice_date: invoice.invoice_date,
          expiry_date: invoice.expiry_date,
          invoice_number: invoice.invoice_number,
          client_name: invoice.client?.business_name,
          amount: subTotal + discount,
          discount: discount,
          sub_total: subTotal,
          // vat_amount is Tax/Vat 1, tax1_amount is Tax/Vat 2 - the API field
          // names are off by one against the labels the app has always used.
          tax1: parseFloat(invoice.vat_amount) || 0,
          tax2: parseFloat(invoice.tax1_amount) || 0,
          total: total,
          payments: paid,
          outstanding: this.balanceDue(invoice),
          category: this.xlsCategoryLabel(invoice.invoice_status),
          category_color: this.xlsStatusColor(invoice.invoice_status),
          status: flag.label,
          status_color: flag.color,
          note: hasNote ? "View" : "",
          attachment: hasFile ? "View" : "",
          _invoice_number: invoice.invoice_number,
        };
      });
    },
    xlsTotals() {
      // Summed off the rendered rows so every money column adds up against
      // what is actually on screen.
      return this.xlsColumns.reduce((totals, column) => {
        if (column.total) {
          totals[column.key] = this.xlsRows.reduce(
            (sum, row) => sum + (parseFloat(row[column.key]) || 0),
            0
          );
        }
        return totals;
      }, {});
    },
  }
};
</script>

<style scoped>
/* Status badges are informational only - keep the default arrow cursor.
   !important is needed to beat the global `a { cursor: pointer !important }`. */
.card-action-nav .status-badge,
.log-status,
.log-status * {
  cursor: default !important;
}

/* Footer totals (Total / Paid / Balance Due): full-width rows, flush right.
   The footer grows to fit long amounts so text never overflows back to the left. */
.card-horizontal-list .card-footer {
  flex-basis: auto;
  min-width: 9.125rem;
}
.card-horizontal-list .card-footer .footer-list-wraper {
  align-items: stretch;
}
.card-horizontal-list .card-footer .footer-list {
  width: 100%;
}
.card-horizontal-list .card-footer .footer-list li {
  text-align: right;
  white-space: nowrap;
}

/* list / group view switch */
.search-option-menu .nav-item .nav-link.list-view,
.search-option-menu .nav-item .nav-link.grid-view {
  border: 2px solid transparent;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-option-menu .nav-item .nav-link.list-view img,
.search-option-menu .nav-item .nav-link.grid-view img {
  max-width: 22px;
  opacity: 0.55;
}
.search-option-menu .nav-item .nav-link.view-active {
  border-color: #f1aa2c;
  background-color: #fff;
}
.search-option-menu .nav-item .nav-link.view-active img {
  opacity: 1;
}

/* group view */
.group-client-card {
  cursor: pointer;
}
.group-client-card:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.14);
}
.group-empty {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  color: #8a94a3;
}
.group-breadcrumb {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
/* equal thirds so the title sits in the true centre */
.group-breadcrumb .crumb-spacer {
  flex: 1;
}
.group-breadcrumb .back-link {
  flex: 1;
  color: #4198ac;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
}
.group-breadcrumb .crumb-title {
  flex: 1;
  text-align: center;
  font-weight: 700;
  color: #222;
}
.group-breadcrumb .crumb-count {
  flex: 1;
  text-align: right;
  color: #8a94a3;
  font-size: 13px;
}

.custom-scroll {
  max-height: calc(100vh - 280px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 5px;
  padding-bottom: 15px;
}
.custom-scroll::-webkit-scrollbar {
  width: 6px;
}
.custom-scroll::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
.custom-scroll::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 4px;
}
.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

/* The XLS grid scrolls horizontally inside its own wrapper. Bootstrap columns
   are flex items with `min-width: auto`, so without this the 900px-wide grid
   stretches the column and overflows the page instead of scrolling. */
.xls-grid-col {
  min-width: 0;
  overflow: hidden;
}
</style>
